import React, { useState, useEffect, useRef } from "react";
import {
  Warning,
  RadioSelector,
  AddressWrapped,
  ManualPoliceAddress,
  Button,
  CheckboxSelector,
  ErrorMsg,
  OtherNames
} from "@onegovbugs/onegov-react-components";
import Select from "react-select";
import styles from "./applicantDetails.module.scss";
import { storeApplicantDetails, saveApplication, process2FA } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  isSelected,
  isCompleted,
  isAustralianPhoneNumberOrNull,
  isValidEmail,
  validate,
  isNumeric,
  scrollToError
} from "../../utils/Validation";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";
import ScrollToTop from "../../utils/scrollToTop";
import { objOfJsonArrayItem } from "../../utils/FormatHelper";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
import countryList from "react-select-country-list";
import moment from "moment";
import { TATTOO_OPERATOR_FORM } from "../../constants";

const ApplicantDetails = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const form = useSelector(state => state.form);
  const applicantDetails = useSelector(state => state.applicantDetails);
  const countryNames = countryList().getData();
  const twoFA = useSelector((state) => state.twoFA);


  const otherNamesRef = React.createRef();


  const twoFAData = twoFA && twoFA.data ? twoFA.data : { firstName: "", lastName: "", day: "", month: "", year: "" };
  const twoFaVerified = twoFA && twoFA.twoFaVerified ? twoFA.twoFaVerified : false;

  const [hasOtherNames, setHasOtherNames] = useState(
    applicantDetails ? applicantDetails.hasOtherNames : null
  );
  const [otherNames, setOtherNames] = useState(
    applicantDetails && applicantDetails.otherNames
      ? applicantDetails.otherNames.map(on => ({ ...on }))
      : [{ firstName: "", middleName: "", lastName: "" }]
  );
  const [placeOfBirth, setPlaceOfBirth] = useState(
    applicantDetails && applicantDetails.placeOfBirth
      ? applicantDetails.placeOfBirth
      : { country: "Australia", state: "NSW", town: "" }
  );

  const [identificationDetails, setIdentificationDetails] = useState(
    applicantDetails && applicantDetails.identificationDetails
      ? applicantDetails.identificationDetails
      : { cardNumber: "", stateIssued: "NSW" }
  );

  const [contactPart, setContactPart] = useState(
    applicantDetails && applicantDetails.contactPart
      ? applicantDetails.contactPart
      : { emailAddress: "", mobileNo: "", phoneNo: "" }
  );

  const [sameAsResidential, setSameAsResidential] = useState(
    applicantDetails && applicantDetails.sameAsResidential
      ? applicantDetails.sameAsResidential
      : []
  );
  const [manualAddressResidentialValue, setManualAddressResidentialValue] = useState(
    applicantDetails && applicantDetails.addressResidential
      ? applicantDetails.addressResidential
      : {}
  );

  const [manualAddressPostalValue, setManualAddressPostalValue] = useState(
    applicantDetails && applicantDetails.addressPostal
      ? applicantDetails.addressPostal
      : {}
  );

  const [manualErrorsListResidential, setManualErrorsListResidential] = useState([]);
  const [manualErrorsListPostal, setManualErrorsListPostal] = useState([]);

  const [isTwoFaPopulated, setIsTwoFaPopulated] = useState(
    applicantDetails && applicantDetails.isTwoFaPopulated
      ? applicantDetails.isTwoFaPopulated
      : false
  );

  const defaultCheckboxAddressValue = {
    value: 1,
    label: "Residential address is same as postal address"
  };

  const checkboxAddressValues = [defaultCheckboxAddressValue];

  const [residentialAddressErrorClasses, setResidentialAddressErrorClasses] = useState({});
  const [postalAddressErrorClasses, setPostalAddressErrorClasses] = useState({});

  const radioOptionsYesNo = [
    {
      value: "yes",
      label: "Yes"
    },
    {
      value: "no",
      label: "No"
    }
  ];
  const allStates = [
    {
      value: "NSW",
      label: "NSW"
    },
    {
      value: "QLD",
      label: "QLD"
    },
    {
      value: "SA",
      label: "SA"
    },
    {
      value: "TAS",
      label: "TAS"
    },
    {
      value: "VIC",
      label: "VIC"
    },
    {
      value: "WA",
      label: "WA"
    },
    {
      value: "ACT",
      label: "ACT"
    },
    {
      value: "NT",
      label: "NT"
    }
  ];

  const [showErrors, setShowErrors] = useState(false);
  const [showErrorsOtherNames, setShowErrorsOtherNames] = useState(false);

  useEffect(
    () => {
      validate(validators, setErrors);
    },
    [hasOtherNames, otherNames, placeOfBirth, contactPart, identificationDetails,
      manualAddressResidentialValue, manualAddressPostalValue, sameAsResidential]
  );

  useEffect(
    () => {
      if (isTwoFaPopulated != true) {
        const _mobileNumber = twoFAData.mobileNumber && twoFAData.mobileNumber != "" ? twoFAData.mobileNumber : contactPart.mobileNo;
        const _emailAddress = twoFAData.emailAddress && twoFAData.emailAddress != "" ? twoFAData.emailAddress : contactPart.emailAddress;
        setContactPart({ ...contactPart, mobileNo: _mobileNumber, emailAddress: _emailAddress });

        const _birthCountry = twoFAData.countryOfBirth && twoFAData.countryOfBirth != "" ? twoFAData.countryOfBirth : placeOfBirth.country;
        const _birthState = twoFAData.stateOfBirth && twoFAData.stateOfBirth != "" ? twoFAData.stateOfBirth : placeOfBirth.state;
        const _birthTown = twoFAData.townOfBirth && twoFAData.townOfBirth != "" ? twoFAData.townOfBirth : placeOfBirth.town;
        setPlaceOfBirth({ ...placeOfBirth, country: _birthCountry, state: _birthState, town: _birthTown });

        const _cardNumber = twoFAData.driverLicenceNo && twoFAData.driverLicenceNo != "" ? twoFAData.driverLicenceNo : identificationDetails.cardNumber;
        const _stateIssued = twoFAData.drierLicenceIssueState && twoFAData.drierLicenceIssueState != "" ? twoFAData.drierLicenceIssueState : identificationDetails.stateIssued;
        setIdentificationDetails({ ...identificationDetails, cardNumber: _cardNumber, stateIssued: _stateIssued });

        if (twoFAData.addressses) {
          if (twoFAData.addressses.length > 0) { setSameAsResidential([]); }

          twoFAData.addressses.map((el, i) => {
            // debugger;
            // let _manualAddress = {
            //   "propertyName": el.propertyName ? el.propertyName : "",
            //   "unitNo": el.unitNo ? el.unitNo : "",
            //   "streetNoStart": el.streetNoStart ? el.streetNoStart : "",
            //   "streetNoEnd": el.streetNoEnd ? el.streetNoEnd : "",
            //   "streetName": el.streetName ? el.streetName : "",
            //   "streetType": el.streetType ? el.streetType : "",
            //   "suburb": el.suburb ? el.suburb : "",
            //   "state": el.state ? el.state : "",
            //   "postCode": el.postCode ? el.postCode : ""
            // }

            if (el.addressType === "Residential") {
              setManualAddressResidentialValue({
                manualAddress: {
                  propertyName: el.propertyName ? el.propertyName : "",
                  unitNo: el.unitNo ? el.unitNo : "",
                  streetNoStart: el.streetNoStart ? el.streetNoStart : "",
                  streetNoEnd: el.streetNoEnd ? el.streetNoEnd : "",
                  streetName: el.streetName ? el.streetName : "",
                  streetType: el.streetType ? el.streetType : "",
                  suburb: el.suburb ? el.suburb : "",
                  state: el.state ? el.state : "",
                  postCode: el.postCode ? el.postCode : ""
                }
              });
              //setManualAddressResidentialValue(_manualAddress);
            }
            if (el.addressType === "Postal") {
              setManualAddressPostalValue({
                manualAddress: {
                  propertyName: el.propertyName ? el.propertyName : "",
                  unitNo: el.unitNo ? el.unitNo : "",
                  streetNoStart: el.streetNoStart ? el.streetNoStart : "",
                  streetNoEnd: el.streetNoEnd ? el.streetNoEnd : "",
                  streetName: el.streetName ? el.streetName : "",
                  streetType: el.streetType ? el.streetType : "",
                  suburb: el.suburb ? el.suburb : "",
                  state: el.state ? el.state : "",
                  postCode: el.postCode ? el.postCode : ""
                }
              });
              // setManualAddressPostalValue({ ..._manualAddress });
            }
          });
        }
      }
    },
    [twoFA]
  );

  const storeData = (finished) => {
    // so that next time we shuold not copy from 2fa data


    dispatch(
      storeApplicantDetails({
        isTwoFaPopulated: true,
        hasOtherNames: hasOtherNames,
        otherNames: otherNames,
        placeOfBirth: placeOfBirth,
        identificationDetails: identificationDetails,
        contactPart: contactPart,
        sameAsResidential: sameAsResidential,
        step: 1,
        finished,
        addressResidential: {
          addressType: "Residential",
          enterManually: true,
          manualAddress: manualAddressResidentialValue.manualAddress,
          addressLookup: []
        },
        addressPostal: {
          addressType: "Postal",
          enterManually: true,
          manualAddress: sameAsResidential.length > 0 ? manualAddressResidentialValue.manualAddress : manualAddressPostalValue.manualAddress,
          addressLookup: []
        }
      })
    );
  };


  const validateManualAddress = (manualValue, type) => {
    const manualAddress = manualValue.manualAddress;
    let errorListString = "";
    let flag = true;
    let addressErrorClasses = {
      propertyName: "",
      unitNumber: "",
      numberPart1: "",
      numberPart2: "",
      streetName: "",
      streetType: "",
      suburb: "",
      state: "",
      postcode: ""
    };
    let errorMessage = "Address field(s) are required.";

    if (manualAddress) {
      if (!isCompleted(manualAddress.propertyName) && !isCompleted(manualAddress.streetName)) {
        //errorListString = 'Property Name or Street Name is required,';
        flag = false;
        addressErrorClasses.propertyName = styles.errorInput;
      }
      if (!isCompleted(manualAddress.suburb)) {
        //errorListString += 'Suburb is required,';
        flag = false;
        addressErrorClasses.suburb = styles.errorInput;
      }
      if (!isCompleted(manualAddress.state)) {
        //errorListString += 'Please select state,';
        flag = false;
        addressErrorClasses.state = styles.errorInput;
      }
      if (!isCompleted(manualAddress.postCode)) {
        //errorListString += 'Invalid postcode';
        flag = false;
        addressErrorClasses.postcode = styles.errorInput;
      }
      else {
        if (!(isNumeric(manualAddress.postCode) && manualAddress.postCode.length == 4)) {
          //errorListString += 'Invalid postcode';
          flag = false;
          addressErrorClasses.postcode = styles.errorInput;
          errorMessage = "Address field(s) are invalid.";
        }
      }


      if (type === "Residential") {
        //setManualErrorsListResidential(errorListString.split(','));
        setManualErrorsListResidential(!flag ? [errorMessage] : []);
        setResidentialAddressErrorClasses(addressErrorClasses);
      } else {
        setManualErrorsListPostal(!flag ? [errorMessage] : []);
        setPostalAddressErrorClasses(addressErrorClasses);
      }

    }

    return flag;
  }

  const validators = [
    {
      fieldName: "otherNames",
      fieldValue: {},
      isValid: () => otherNamesRef.current.validate()
    },
    {
      fieldName: "townOfBirth",
      fieldValue: placeOfBirth.town,
      isValid: v => placeOfBirth.country.toLowerCase() != "australia" || isCompleted(v)
    },
    {
      fieldName: "cardNumber",
      fieldValue: identificationDetails.cardNumber,
      isValid: v => isCompleted(v)
    },
    {
      fieldName: "phoneNumber",
      fieldValue: contactPart.phoneNo,
      isValid: v => isAustralianPhoneNumberOrNull(v)
    },
    {
      fieldName: "mobileNumber",
      fieldValue: contactPart.mobileNo,
      isValid: v => v !== "" ? isAustralianPhoneNumberOrNull(v) : true
    },
    {
      fieldName: "email",
      fieldValue: contactPart.emailAddress,
      isValid: v => v !== "" ? isValidEmail(v) : true
    },
    {
      fieldName: "isMobileEmailFilled",
      fieldValue: contactPart.emailAddress,
      isValid: v => isCompleted(v) || isCompleted(contactPart.mobileNo)
    },
    {
      fieldName: "addressResidential",
      fieldValue: manualAddressResidentialValue,
      isValid: v => validateManualAddress(v, "Residential")
    },
    {
      fieldName: "addressPostal",
      fieldValue: manualAddressPostalValue,
      isValid: (v) => {
        let flagValid = false;
        if (sameAsResidential.length > 0) {
          flagValid = true;
        } else {
          return validateManualAddress(v, "Postal");
        }
        return flagValid;
      }
    }
  ];

  const [errors, setErrors] = useState({
    hasOtherNames: false,
    otherNames: false,
    townOfBirth: false,
    cardNumber: false,
    phoneNumber: false,
    mobileNumber: false,
    email: false,
    addressResidential: false,
    addressPostal: false,
  });

  const [errorsOtherNames, setErrorsOtherNames] = useState({
    otherNames: false
  });

  const handleFirstNameChange = (i, event) => {
    let values = [...otherNames];
    values[i].firstName = event.target.value;
    setOtherNames(values);
  };
  const handleMiddleNameChange = (i, event) => {
    let values = [...otherNames];
    values[i].middleName = event.target.value;
    setOtherNames(values);
  };
  const handleLastNameChange = (i, event) => {
    let values = [...otherNames];
    values[i].lastName = event.target.value;
    setOtherNames(values);
  };

  const addNameClick = () => {
    setOtherNames([
      ...otherNames,
      { firstName: "", middleName: "", lastName: "" }
    ]);
  };

  const removeNameClick = i => {
    let values = [...otherNames];
    values.splice(i, 1);
    setOtherNames([...values]);
  };

  const renderAnotherNameRow = () => {
    return otherNames.map((el, i) => (
      <div key={i} className={styles.topMargin24}>
        <div className={"row"}>
          <div className="col-12 col-sm-4">
            <label htmlFor={"first-name-" + i}>First Name</label>
            <input
              id={"first-name-" + i}
              className={styles.inputBox}
              placeholder="First Name"
              maxLength="20"
              value={el.firstName || ""}
              onChange={handleFirstNameChange.bind(this, i)}
            />
            {errorsOtherNames.otherNamesFirstName && showErrorsOtherNames ?
              <ErrorMsg className={"ErrorMsg_error"}
                type={"error"}
                description={'First Name is required.'}
              /> : null}
          </div>
          <div className="col-12 col-sm-3">
            <label htmlFor={"middle-name-" + i}>Middle Name</label>
            <input
              id={"middle-name-" + i}
              className={styles.inputBox}
              placeholder="Middle Name"
              maxLength="20"
              value={el.middleName || ""}
              onChange={handleMiddleNameChange.bind(this, i)}
            />

          </div>
          <div className="col-11 col-sm-4">
            <label htmlFor={"last-name-" + i}>Last Name</label>
            <input
              id={"last-name-" + i}
              className={styles.inputBox}
              placeholder="Last Name"
              maxLength="20"
              value={el.lastName || ""}
              onChange={handleLastNameChange.bind(this, i)}
            />
            {errorsOtherNames.otherNamesLastName && showErrorsOtherNames ?
              <ErrorMsg className={"ErrorMsg_error"}
                type={"error"}
                description={'Last Name is required.'}
              /> : null}
          </div>
          <div className={styles.removeNameContainer + " col-1"}>
            {otherNames.length > 1 &&
              (<ClearIcon onClick={removeNameClick.bind(this, i)} />)
            }
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          <div className={styles.shadowBox}>
            {twoFaVerified && (<Warning type={"success"}>
              <p>Record successfully matched.</p>
            </Warning>)}
            <h3>{twoFAData.firstName + " " + (twoFAData.middleName ? (twoFAData.middleName + " ") : "") + twoFAData.lastName}</h3>
            <p>Date of birth: {moment(twoFAData.month + "/" + twoFAData.day + "/" + twoFAData.year).format("DD/MM/YYYY")}</p>
            <div className={"row " + styles.topMargin24}>
              <div className={"col-12"}>
                <Button
                  onClick={() => {
                    dispatch(
                      storeApplicantDetails({
                        isTwoFaPopulated: false
                      }));
                    dispatch(process2FA((TwoFaUrl) => {
                      sessionStorage["tattooistTwoFASource"] = "applicant"; console.log("sorce", sessionStorage["tattooistTwoFASource"]);
                      window.location = TwoFaUrl;
                    }))
                  }}>
                  Change applicant
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.anotherNames}>
        <OtherNames
          value={{ otherNames: applicantDetails.otherNames, hasOtherNames: applicantDetails.hasOtherNames }}
          primaryName={{ firstName: twoFAData.firstName, lastName: twoFAData.lastName }}
          onChange={(data) => {
            console.log('othernames', data);
            setOtherNames([...data.otherNames]);
            setHasOtherNames(data.hasOtherNames);
          }}
          ref={otherNamesRef}
          showErrors={showErrors}
        />
      </div>
      <hr className={styles.hrLine} />

      <div className={"row"}>
        <div className={"col-12"}>
          <h2 className={styles.headingH2}>Place of birth</h2>
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor={"countryOfBirth"}>Country</label>
          <Select
            id="countryOfBirth"
            value={objOfJsonArrayItem(countryNames, "label", placeOfBirth.country)}
            onChange={obj => {
              setPlaceOfBirth({
                ...placeOfBirth,
                country: obj.label,
                state: (obj.label.toLowerCase() == "australia" ? "NSW" : ""),
                town: ""
              });
            }}
            className={styles.select}
            options={countryNames}
          />
        </div>
        <div className="col-12 col-sm-6">
          {placeOfBirth.country.toLowerCase() == "australia" ? (
            <>
              <label htmlFor={"stateOfBirth"}>State {placeOfBirth.state} </label>
              <Select
                id="stateOfBirth"
                value={objOfJsonArrayItem(allStates, "label", placeOfBirth.state)}
                onChange={obj => {
                  setPlaceOfBirth({ ...placeOfBirth, state: obj.label });
                }}
                className={styles.select}
                options={allStates}
              />
            </>
          ) : null}
        </div>
      </div>
      {placeOfBirth.country.toLowerCase() == "australia" ? (
        <div className={"row " + styles.topMargin24}>
          <div className="col-12 col-sm-6">
            <label htmlFor={"townOfBirth"}>Town</label>
            <input
              id={"townOfBirth"}
              className={styles.inputBox}
              placeholder="Town"
              maxLength="20"
              value={placeOfBirth.town}
              onChange={obj => {
                setPlaceOfBirth({ ...placeOfBirth, town: obj.target.value });
              }}
            />
            {errors.townOfBirth && showErrors ? (
              <ErrorMsg className={"ErrorMsg_error"}
                type={"error"}
                description={"Town is required."}
              />
            ) : null}
          </div>
        </div>
      ) : null}

      <hr className={styles.hrLine} />

      <div className={"row"}>
        <div className={"col-12"}>
          <h2 className={styles.headingH2}>Identification</h2>
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor={"documentNumber"}>
            Driver licence/Photo card number
          </label>
          <input
            id={"documentNumber"}
            className={styles.inputBox}
            maxLength="20"
            placeholder="Driver licence/Photo card number"
            value={identificationDetails.cardNumber}
            onChange={obj => {
              setIdentificationDetails({ ...identificationDetails, cardNumber: obj.target.value });
            }}
          />
          {errors.cardNumber && showErrors ? (
            <ErrorMsg className={"ErrorMsg_error"}
              type={"error"}
              description={"Drivers licence/Photo card number is required."}
            />
          ) : null}
        </div>
        <div className="col-12 col-sm-6">
          <label htmlFor={"stateOfIssued"}>State Issued</label>
          <Select
            id="stateOfIssued"
            value={objOfJsonArrayItem(allStates, "label", identificationDetails.stateIssued)}
            onChange={obj => {
              setIdentificationDetails({ ...identificationDetails, stateIssued: obj.label });
            }}
            className={styles.select}
            options={allStates}
          />
        </div>
      </div>

      <hr className={styles.hrLine} />

      <div className={"row"}>
        <div className={"col-12"}>
          <h2 className={styles.headingH2}>Contact Details</h2>
        </div>
      </div>
      <div className={"row"}>
        <div className="col-12 col-sm-6">
          <label htmlFor={"mobileNumber"}>Mobile number</label>
          <input
            id={"mobileNumber"}
            className={styles.inputBox}
            placeholder="Mobile number"
            maxLength="20"
            value={contactPart.mobileNo}
            onChange={obj => {
              setContactPart({ ...contactPart, mobileNo: obj.target.value });
            }}
          />
          {contactPart.mobileNo != null && contactPart.mobileNo != "" && errors.mobileNumber && showErrors ? (
            <ErrorMsg className={"ErrorMsg_error"}
              type={"error"}
              description={"Mobile number is invalid."}
            />
          ) : null}
        </div>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor={"phoneNumber"}>
            Daytime telephone number (Optional)
          </label>
          <input
            id={"phoneNumber"}
            className={styles.inputBox}
            placeholder="Daytime telephone number"
            maxLength="20"
            value={contactPart.phoneNo}
            onChange={obj => {
              setContactPart({ ...contactPart, phoneNo: obj.target.value });
            }}
          />
          {contactPart.phoneNo != null && contactPart.phoneNo != "" && errors.phoneNumber && showErrors ? (
            <ErrorMsg className={"ErrorMsg_error"}
              type={"error"}
              description={"Daytime telephone number is invalid."}
            />
          ) : null}
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor={"emailAddress"}>
            Email address
          </label>
          <input
            id={"emailAddress"}
            className={styles.inputBox}
            placeholder="Email address"
            maxLength="100"
            value={contactPart.emailAddress}
            onChange={obj => {
              setContactPart({ ...contactPart, emailAddress: obj.target.value });
            }}
          />
          {contactPart.emailAddress != null && contactPart.emailAddress != "" && errors.email && showErrors ? (
            <ErrorMsg className={"ErrorMsg_error"}
              type={"error"}
              description={"Email address is invalid."}
            />
          ) : null}
          {errors.isMobileEmailFilled && showErrors ? (
            <ErrorMsg className={"ErrorMsg_error"}
              type={"error"}
              description={"Either Email or mobile number is mandatory."}
            />
          ) : null}
        </div>
      </div>
      <hr className={styles.hrLine} />
      <div className={"row"}>
        <div className={"col-12"}>
          <label htmlFor={"residentialAddress"} className={styles.h2Style}>
            Residential Address
          </label>
          <ManualPoliceAddress
            value={manualAddressResidentialValue}
            onChange={setManualAddressResidentialValue}
            extraClassNames={showErrors ? residentialAddressErrorClasses : {}}
          />
        </div>
        <div className={"col-12 " + styles.errorContainer}>
          {showErrors ? manualErrorsListResidential.map((el, i) => (
            el !== "" && (<ErrorMsg className={"ErrorMsg_error"}
              key={"errorManual-" + i}
              type={"error"}
              description={el}
            />)
          )) : null}
        </div>
      </div>
      <div className={`row ${styles.extraMargins}`}>
        <CheckboxSelector
          onSelectionChange={v => {
            setSameAsResidential(v);
          }}
          initialValue={sameAsResidential}
          options={checkboxAddressValues}
        />
      </div>
      {sameAsResidential.length === 0 && (<div className={"row"}>
        <div className={"col-12"}>
          <label htmlFor={"postalAddress"} className={styles.h2Style}>
            Postal Address
          </label>
          <ManualPoliceAddress
            value={manualAddressPostalValue}
            onChange={setManualAddressPostalValue}
            extraClassNames={showErrors ? postalAddressErrorClasses : {}}
          />
        </div>
        <div className={"col-12 " + styles.errorContainer}>
          {showErrors ? manualErrorsListPostal.map((el, i) => (
            el != "" && (<ErrorMsg className={"ErrorMsg_error"}
              key={"errorManual-" + i}
              type={"error"}
              description={el}
            />)
          )) : null}
        </div>
      </div>)}
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          {form.form === TATTOO_OPERATOR_FORM ?
            <Button
              onClick={() => {
                if (validate(validators, setErrors)) {
                  props.history.push(`./dashboard`);
                  setShowErrors(false);
                  setShowErrorsOtherNames(false);
                  storeData(true);
                } else {
                  setShowErrors(true);
                  setShowErrorsOtherNames(true);
                  scrollToError();
                }
              }}
            >
              Complete
          </Button> :
            <Button
              onClick={() => {
                if (validate(validators, setErrors)) {
                  props.history.push(`./employment`);
                  setShowErrors(false);
                  setShowErrorsOtherNames(false);
                  storeData();
                } else {
                  setShowErrors(true);
                  setShowErrorsOtherNames(true);
                  scrollToError();
                }
              }}
            >
              Continue
        </Button>}

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step1", () => {
                  {
                    form.form === TATTOO_OPERATOR_FORM ?
                      props.history.push(`./dashboard`) :
                      window.location.href = `${process.env.REACT_APP_BAU_URL}`
                  }
                })
              );
            }}
          >
            Save & exit section
          </Button>

        </div>
      </div>
    </div>
  );
};

export default withRouter(props => <ApplicantDetails {...props} />);
